<template>
    <button :class="classList" @click="sidebarToggle">
      <span class="navbar-toggler-icon"/>
    </button>
</template>

<script>
import { sidebarCssClasses, validBreakpoints, checkBreakpoint } from '@/components/helpers/classes'
import toggleClasses from '@/components/helpers/toggle-classes'

export default {
  name: 'SidebarToggler',
  props: {
    display: {
      type: String,
      default: 'lg'
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classList() {
      return [
        'navbar-toggler'
      ]
    }
  },
  data() {
    return {
      widthWindow: null
    }
  },
  mounted() {
    this.toggle()
  },
  beforeMount() {
    this.widthWindow = window.innerWidth
    window.onresize = () => {
      if (this.widthWindow < 991.6 && (document.getElementsByTagName('body')[0].classList.contains(`sidebar-${this.display}-show`)
        || document.getElementsByTagName('body')[0].classList.contains('sidebar-show'))) {
        this.toggle()
      }
      this.widthWindow = window.innerWidth
    }
  },
  methods: {
    sidebarToggle(e) {
      e.preventDefault()
      e.stopPropagation()
      this.toggle()
    },
    toggle() {
      const scroll = window.pageYOffset
      window.scrollBy(0, 1)
      if (scroll === window.pageYOffset) {
        window.scrollBy(0, -1)
      }
      const [display, mobile] = [this.display, this.mobile]
      let cssClass = sidebarCssClasses[0]
      if (!mobile && display && checkBreakpoint(display, validBreakpoints)) {
        cssClass = `sidebar-${display}-show`
      }
      toggleClasses(cssClass, sidebarCssClasses)
    }
  }
}
</script>

<style scoped>
  #menuDiv{
    color: #fff;
    font-size: large;
  }
</style>
